<script lang="ts">
  import InfoIcon from "../../public/icons/info_icon.svelte";
  import { updated, organizationLocation, OrganizationLocation, Widget, widgetInfo, WidgetType } from "../store";
  import Background from "./Background.svelte";
  import Footer from "./Footer.svelte";
  import WxImageContainer from "./WxImageContainer.svelte";
  import { onMount, tick } from 'svelte';
  import { addUTMsToLogoLink } from '../utils/widgetUtils';

  onMount(async () => {
      await tick();
      addUTMsToLogoLink();
  });
  
  let title: string = "";
  let updateTime: string = "";

  organizationLocation.subscribe((value: OrganizationLocation) => {
    if(value)
      title = value.name;
  });

  updated.subscribe((value: Date) => {
    updateTime = value.toLocaleDateString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  });

  let widget: Widget;
  widgetInfo.subscribe((value: Widget) => {
    if (value)
    {
      widget = value;
    }
  });

  function checkMessageExpired(expirationTime: Date): boolean {
    let currentTime = new Date();
    let currentUtc = new Date(
      currentTime.getUTCFullYear(),
      currentTime.getUTCMonth(),
      currentTime.getUTCDate(),
      currentTime.getUTCHours(),
      currentTime.getUTCMinutes(),
      currentTime.getUTCSeconds()
    )
    return currentUtc < new Date(expirationTime);
  }
  let hasMessage: boolean = false;
  $: hasMessage = widget.headerMessage && ( checkMessageExpired(widget.headerMessageExpiration) || widget.headerMessageExpiration == undefined);

</script>

<div class="pw-card pw-flex-column pw-justify-between tk-proxima-nova regular-font-size {hasMessage && "has-message"}" >
  <Background />
  {#if widget.headerMessage && ( checkMessageExpired(widget.headerMessageExpiration) || widget.headerMessageExpiration == undefined)}
    <div class="pw-flex value header-message">
      <div class="pw-flex pw-align-center weatherIcon" style="margin-right: 0px;">
        <InfoIcon/>
      </div>
      <div class="" style="flex-grow: 0; width: 90%; overflow-wrap:break-word ">
        {widget.headerMessage}
      </div>
    </div>
  {/if}
  <!-- Header component -->
  <div class="pw-flex pw-justify-between pw-align-center pw-header">
    <div class="header-text">
      <h4>{title}</h4>
      <h6>Updated {updateTime}</h6>
    </div>
    <div class="pw-flex pw-justify-center pw-align-center">
      <a href="https://perryweather.com/" target="_blank" rel="noreferrer noopener">
        <img src="/icons/logo_text.svg" alt="Weather data provided by Perry Weather" class="pw-logo"/>
      </a>
    </div>
  </div>
  
  {#if widget.type === WidgetType.IMG || widget.type === WidgetType.RADAR || widget.type === WidgetType.DEF}
    <WxImageContainer type={widget.primaryCondition}/>
  {/if}

  {#key widget}
    <Footer conditionOnWidget={widget.widgetConditions} forecasts={widget.widgetForecasts} />
  {/key}
    
  <div data-iframe-height></div>
<style scoped>
  .pw-header{
    display: flex;
    flex-direction: column-reverse;
  }
  .header-text{
    text-align: left;
  }

  /* .pw-card {
    max-height: 100vh;

  } */
  .pw-logo{
    width: 200px;
  }
  
  .pw-card h4 {
    color: var(--title-color);
    margin-bottom: 0;
    font-size: 32px;
    pointer-events: none;
  }

  .pw-card h6 {
    color: #767f8a;
    margin-bottom: 10px;
    font-size: 20px;
    pointer-events: none;
  }

  @media(min-width: 330px){
    .pw-header{
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .header-text{
      text-align: left;
    }
  }

  @media(max-width: 330px){
    .header-text{
      text-align: center;
    }
  }

  @media(max-width: 480px) {
    .pw-card h4 {
      font-size: 24px;
    }

    .pw-card h6 {
      font-size: 12px;
    }
    .pw-logo{
      width: 150px;
    }
  }

  @media(min-width: 1920px){
    .pw-logo{
      width: 300px;
    }

    .pw-card h4 {
      font-size: 50px;
    }

    .pw-card h6 {
      font-size: 30px;
    }

  }

  @media(min-width: 3840px){
    .pw-logo{
      width: 600px;
    }

    .pw-card h4 {
      font-size: 100px;
    }

    .pw-card h6 {
      font-size: 70px;
    }

  }

  /* @media(min-width: 1920px){
    .pw-card {
      height: 100vh;
      overflow: scroll
    }
  } */

/* Need to scroll so that we don't see white background when there is overflow.
  This issue is mostly because of the message height changing pushing the actual content height greater than 100vh
*/
  @media(min-width: 1080px){
    .pw-card {
      height: 100vh;
      overflow: scroll;
    }
  }
  
</style>

</div>
